import { AbstractControl, UntypedFormControl } from '@angular/forms';

export function isRequired(formControl: AbstractControl): boolean {
    if (!formControl || !formControl.validator || !formControl.validator(new UntypedFormControl(''))) {
        return false;
    }
    return formControl.validator(new UntypedFormControl('')).required;
}
